export default [{
    path: 'privateAssets',
    redirect: '/privateAssets/assetManagement',
    children: [{
        path: '/privateAssets/assetManagement',
        meta: {
            title: "资产管理",
            name: 'assetManagement',
            keepAlive: true
        },
        components: {
            mains: () => import('../views/privateAssets/assetManagement.vue')
        }
    },{
        path: '/privateAssets/assetArchitecture',
        meta: {
            title: "资产架构",
            name: 'assetArchitecture',
            keepAlive: true
        },
        components: {
            mains: () => import('../views/privateAssets/assetArchitecture.vue')
        }
    },{
        path: '/privateAssets/detail',
        meta: {
            title: "资产详情",
            name: 'detail',
            keepAlive: true
        },
        components: {
            mains: () => import('../views/privateAssets/detail.vue')
        }
    } ]
}]
